<div class="overflow-hidden" [formGroup]="form()">
  <div class="mb-4">
    <p class="paragraph-small-medium text-text-primary">Tous les champs dans cet onglet sont obligatoires.</p>
  </div>
  <div class="mb-4 w-2/3">
    <hlm-field>
      <label hlmLabel for="nom-jalon">Nom du jalon <span class="text-danger">*</span></label>
      <input id="nom-jalon" hlmInput type="text" formControlName="nom" required />
      <hlm-field-description>Il sera numéroté par défaut.</hlm-field-description>
      <hlm-field-error>Ce champ est obligatoire</hlm-field-error>
    </hlm-field>
  </div>

  <div class="mb-4 w-2/3">
    <hlm-field>
      <label hlmLabel for="niveau-cec">Niveau CEC <span class="text-danger">*</span></label>
      <input id="niveau-cec" hlmInput type="number" formControlName="niveauCec" step="1" min="3" max="8" required />
      <hlm-field-description>Nombre compris entre 3 et 8.</hlm-field-description>
      <hlm-field-error>Ce champ est obligatoire</hlm-field-error>
    </hlm-field>
  </div>
</div>
